import React from 'react';
import ReservationDateView from './views/ReservationDateView';
import { useReservationDate } from './hooks/ReservationDate.hook';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as Yup from 'yup';

const ReservationDateController = () => {
  const { idSubSpace } = useParams();
  const {
    loading,
    error,
    handleSubmit,
    goBack,
    goToReservationTime,
  } = useReservationDate(idSubSpace);
  
  const languageData = useSelector(state => state.lenguage?.lang);
  const initialValues = {
    email: '',
    password: '',
    confirmPassword: '',
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string().email('Invalid email').required('Required'),
    password: Yup.string().min(6, 'Minimum 6 characters').required('Required'),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref('password'), null], 'Passwords must match')
      .required('Required'),
  });

  const onReservationDate = async values => {
    console.log('Simulated Reservation Time with values:', values);
  };

  return (
    <ReservationDateView
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={values => handleSubmit(values, onReservationDate)}
      loading={loading}
      error={error}
      languageData={languageData}
      goBack={goBack}
      goToReservationTime={goToReservationTime}
    />
  );
};

export default ReservationDateController;
